import { api } from '@/Data/api';
import ss from '../Session';
import {
    SubmitAnswerResponse,
    TopikResponse
} from './types';

/**
 * Submit or update an individual answer during an active attempt
 * @param params Object with attemptid, questionid, and answer
 * @returns Promise with submitted answer or null if failed
 */
export const submitAnswer = async (params: {
    attemptid: string;
    questionid: number;
    answer: string;
}): Promise<SubmitAnswerResponse | null> => {
    try {
        const res = await api.post<TopikResponse<SubmitAnswerResponse>>('/topik/answer', params, {
            headers: {
                Authorization: `Bearer ${ss.getCurrentSession().jwt}`
            }
        });
        
        return res.data?.code === 200 ? (res.data.data ?? null) : null;
    } catch (e) {
        console.error('Failed to submit answer:', e);
        return null;
    }
};